import { Option } from "../../../components/reusable-components/form/FormAutocomplete";
import { SettingDefinition } from "./SettingDefinition";
import { EntityType } from "./enums/EntityType";
import { SettingValueType } from "./enums/SettingValueType";

export interface SettingDefinitionEditConstructor
  extends Partial<
    Omit<
      SettingDefinition,
      "id" | "created_at" | "updated_at" | "entity_type" | "type"
    >
  > {
  entity_type?: Option<EntityType>;
  type?: Option<SettingValueType>;
}

export class SettingDefinitionEdit
  implements
    Partial<Omit<SettingDefinition, "id" | "created_at" | "updated_at">>
{
  public readonly entity_type?: EntityType;
  public readonly key?: string;
  public readonly type?: SettingValueType;
  public readonly default_value?: string | number | null;
  public readonly description?: string | null;

  constructor(data: SettingDefinitionEditConstructor) {
    this.entity_type = data.entity_type?.value;
    this.key = data.key;
    this.type = data.type?.value;
    this.default_value = data.default_value ?? null;
    this.description = data.description ?? null;
  }
}
